import * as React from "react"
import type { SVGProps } from "react"
const SvgAlertTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M2.73 21.71a1 1 0 0 1-.85-.5 1 1 0 0 1-.14-.48 1 1 0 0 1 .14-.52l9.25-16a1 1 0 0 1 .87-.5q.25 0 .49.13a1 1 0 0 1 .38.37l9.26 16q.15.25.13.52a1 1 0 0 1-.14.48 1 1 0 0 1-.85.5zm1.72-2h15.1L12 6.71zm7.55-1q.42 0 .71-.28a1 1 0 0 0 .29-.72 1 1 0 0 0-.29-.7 1 1 0 0 0-.71-.3 1 1 0 0 0-.71.3 1 1 0 0 0-.29.7q0 .43.29.72t.71.28m0-3q.42 0 .71-.28a1 1 0 0 0 .29-.72v-3a1 1 0 0 0-.29-.7 1 1 0 0 0-.71-.3 1 1 0 0 0-.71.3 1 1 0 0 0-.29.7v3q0 .43.29.72t.71.28" />
  </svg>
)
export default SvgAlertTriangle
